/**
 * The autohide compoennt.
 */
export class Autohide {
    /**
     * Create a new autohide instance.
     * @param args - The constructor arguments.
     */
    constructor(args) {
        this.element = args.element;
        this.leafletMap = args.leafletMap;
        this.state = { isHidden: false, isLocked: false };
        this.setElementClassName();
        this.setEventListeners();
        this.updateState(this.state);
        this.timeoutFn = this.createTimeoutFn();
    }
    /**
     * Show the element.
     */
    show() {
        this.updateState({ isHidden: false });
    }
    /**
     * Hide the element.
     */
    hide() {
        this.updateState({ isHidden: true });
    }
    /**
     * Lock the autohide element's visibility.
     */
    lock() {
        this.updateState({ isLocked: true });
    }
    /**
     * Lock the autohide element's visibility.
     */
    unlock() {
        this.updateState({ isLocked: false });
    }
    /**
     * Set the component state.
     * @param state - The new (partial) component state.
     */
    updateState(state) {
        this.state = Object.assign(Object.assign({}, this.state), state);
        this.updateDom();
    }
    /**
     * Destroy the autohide instance.
     */
    destroy() {
        clearTimeout(this.timeoutFn);
        this.removeElementClassName();
        this.removeEventListeners();
    }
    /**
     * Set the element's autohide class name.
     */
    setElementClassName() {
        this.element.classList.add(Autohide.className);
    }
    /**
     * Remove the element's autohide class name.
     */
    removeElementClassName() {
        this.element.classList.remove(Autohide.className);
    }
    /**
     * Set the autohide event listeners.
     */
    setEventListeners() {
        this.element.addEventListener('click', this.onClick.bind(this));
        this.element.addEventListener('mouseleave', this.onMouseleave.bind(this));
        ['click', 'touchstart'].forEach((event) => {
            document.addEventListener(event, this.onDocumentEvent.bind(this));
        });
        this.leafletMap.on('fullscreenchange', this.onFullscreenchange.bind(this));
    }
    /**
     * Remove the autohide event listeners.
     */
    removeEventListeners() {
        this.element.removeEventListener('click', this.onClick.bind(this));
        this.element.removeEventListener('mouseleave', this.onMouseleave.bind(this));
        ['click', 'touchstart'].forEach((event) => {
            document.removeEventListener(event, this.onDocumentEvent.bind(this));
        });
        this.leafletMap.off('fullscreenchange', this.onFullscreenchange.bind(this));
    }
    /**
     * Click event listener.
     */
    onClick() {
        this.show();
    }
    /**
     * Mouseleave event listener.
     */
    onMouseleave() {
        this.hide();
    }
    /**
     * Event listener for fullscreen event.
     */
    onFullscreenchange() {
        if (!this.leafletMap.isFullscreen())
            return;
        this.timeoutFn = this.createTimeoutFn();
        this.show();
    }
    /**
     * Event listener for events triggered on the document element.
     */
    onDocumentEvent(event) {
        if (this.timeoutFn !== undefined)
            return;
        const target = event.target;
        const isPartOfControl = target === this.element || this.element.contains(target);
        if (!isPartOfControl) {
            this.hide();
        }
    }
    /**
     * Create a new autohide timeout function.
     */
    createTimeoutFn() {
        return window.setTimeout(() => {
            this.hide();
        }, Autohide.autohideDelay);
    }
    /**
     * Update the DOM according to the component's state.
     */
    updateDom() {
        if (this.state.isHidden && !this.state.isLocked) {
            this.element.classList.add(Autohide.classNameModifier);
        }
        else {
            this.element.classList.remove(Autohide.classNameModifier);
        }
    }
}
/**
 * The delay until the control should be hidden.
 */
Autohide.autohideDelay = 5000;
/**
 * The component base CSS class.
 */
Autohide.className = 'maap_c-autohide';
/**
 * The CSS class modifier to indicate that the element is hidden.
 */
Autohide.classNameModifier = 'is-hidden';
//# sourceMappingURL=Autohide.js.map